import script from "./ProjectHoursDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectHoursDetails.vue?vue&type=script&setup=true&lang=js"

import "./ProjectHoursDetails.vue?vue&type=style&index=0&id=a31bbd2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a31bbd2a"]])

export default __exports__